import { ref, watch } from 'vue'
import { useWorkspacesStore } from '@/stores/workspaces.store'

export default function useList() {
  const listTable = ref([])

  const searchQuery = ref('')
  const options = ref({
    page: ref(1),
    itemsPerPage: 9,
  })
  const totalListTable = ref(0)
  const loading = ref(true)
  const nbPages = ref(0)
  const page = ref(1)
  const workspaceStore = useWorkspacesStore()

  const fetchDatas = () => {
    workspaceStore
      .getWorkspaces({ search: searchQuery.value, options: { page: page.value, itemsPerPage: 9 } })
      .then(data => {
        listTable.value = data.data
        totalListTable.value = data.count
        nbPages.value = Math.ceil(totalListTable.value / options.value.itemsPerPage)
        loading.value = false
      })
      .catch(() => {
        listTable.value = []
        totalListTable.value = 0
        nbPages.value = 0
        loading.value = false
      })
  }

  fetchDatas()
  watch([searchQuery, page], () => {
    loading.value = true
    fetchDatas()
  })

  workspaceStore.$subscribe(async mutation => {
    if (mutation.payload) {
      const index = listTable.value.findIndex(item => item.id === mutation.payload.item.id)
      if (mutation.payload.eventType === 'UPDATE') {
        if (index !== -1) listTable.value.splice(index, 1, mutation.payload.item)
      } else if (mutation.payload.eventType === 'INSERT') {
        if (index === -1) listTable.value.push(mutation.payload.item)
      } else if (mutation.payload.eventType === 'DELETE') {
        if (index !== -1) listTable.value.splice(index, 1)
      }
    }
  })

  return {
    searchQuery,
    page,
    listTable,
    totalListTable,
    loading,
    fetchDatas,
    nbPages,
  }
}
